import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type BasicInfoIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function BasicInfoIcon({
  className,
  pathClassName = "stroke-teachLoop-textPrimary",
  ...props
}: BasicInfoIconProps) {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      className={className}
    >
      <Path
        d="M6.021 20.504c.284-1.394.974-2.138 2.076-3.038a6.167 6.167 0 017.805 0c1.101.9 1.882 1.644 2.165 3.038M12 13.028a3.31 3.31 0 10.001-6.619 3.31 3.31 0 000 6.619z"
        stroke="#000"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
      <Path
        d="M15.25 2.75h-6.5a6 6 0 00-6 6v6.5a6 6 0 006 6h6.5a6 6 0 006-6v-6.5a6 6 0 00-6-6z"
        stroke="#000"
        strokeWidth={1.5}
        className={pathClassName}
      />
    </Svg>
  );
}

export default BasicInfoIcon;
